import React, { Component } from "react";
import { Link } from "react-router-dom";

class SobreCanal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      readmore: false,
      alturaInicial: null,
      scrollInicial: null
    }
    this.textRef = React.createRef();
  }
  componentDidMount(){
    const element = this.textRef.current;
    if(element) {
      const { clientHeight, scrollHeight } = element;
      this.setState({
        alturaInicial: clientHeight,
        scrollInicial: scrollHeight
      });
      if(scrollHeight > clientHeight && !this.state.readmore) {
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const element = this.textRef.current;
    if(element) {
      const { clientHeight, scrollHeight } = element;
      if (clientHeight !== prevState.alturaInicial) {
        this.setState({
          alturaInicial: clientHeight
        })
      }
      if (scrollHeight !== prevState.scrollInicial) {
        this.setState({
          scrollInicial: scrollHeight
        })
      }
      if((scrollHeight > clientHeight || prevState.scrollInicial > prevState.alturaInicial) && !this.state.readmore) {
        this.setState({ readmore: true })
      }
    }
  }

  render(){
    const { channel } = this.props;
    return(
      <>
        <h5 className="subtilteChannel">SOBRE O CANAL</h5>
        <span ref={this.textRef} className="description">{channel.description}</span>
        {
          this.state.readmore &&
          <a className="readMores" href={`/channels/${channel.codename}`}>LEIA MAIS +</a>
        }
      </>
    );
  }
}

export default SobreCanal;
